module.exports = __webpack_public_path__ + "img/filter-close-black.9f112616.svg";